module.exports = __webpack_public_path__ + "img/symbol_13_x4.ced47938.png";